import loadable from '@loadable/component'
import { BrowserRouter, Route, Routes } from 'react-router'
import RootLayout from '@/layouts/root'

const MonacoPage = loadable(() => import(/* webpackChunkName: 'monaco' */ '@/pages/monaco'))
const NoMatch = loadable(() => import('@/components/no-match'))

export const AppRouter = () => {
  return (
    <BrowserRouter basename={import.meta.env?.__BASENAME__ || ''}>
      <Routes>
        <Route path='/' element={<RootLayout />}>
          <Route index element={<MonacoPage />} />
        </Route>
        <Route path='*' element={<NoMatch />} />
      </Routes>
    </BrowserRouter>
  )
}
